module.exports = __webpack_public_path__ + "img/林素琴.f003ff7e.jpg";